import { Link } from "react-router-dom";
import { VideoPlayCircleIcon } from "@/components/Icons";
import { motion } from "framer-motion";

export default function GalleryHighlightSection() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="p-4 py-12 bg-secondary text-black"
    >
      <div className="container flex flex-col gap-4 mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col gap-2"
        >
          <h2 className="font-bold leading-none text-primary text-[clamp(2rem,1.714rem+1.429vw,3rem)] md:flex md:flex-col">
            <span>We are Techies</span>
            <span>but we love to have fun</span>
          </h2>
          <p>
            See what the brilliant Minds of Tech Space have been up to
            lately:
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid gap-4 sm:grid-cols-[2fr_1fr] gallery-container"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            style={{ background: `url(/images/videoplaceholder.jpg)`, backgroundSize: "cover" }}
            className="bg-center bg-cover relative h-80 overflow-hidden grid place-items-center rounded-2xl
            after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:z-10 after:bg-[rgba(0,0,0,0.5)]"
          >
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="relative z-20 grid border-0 rounded-full cursor-pointer place-items-center group text-primary hover:text-secondary"
              aria-label="Play Video"
            >
              <Link to="https://www.instagram.com/reel/DLHwshYMzBL/?igsh=bmkzM3BkajB2em0y">
                <VideoPlayCircleIcon className="w-12 h-12 fill-secondary group-hover:fill-primary" />
              </Link>
            </motion.button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ background: `url(/images/viewgallery.jpg)`, backgroundSize: "cover" }}
            className="bg-center bg-cover relative overflow-hidden rounded-2xl
            after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:z-10 after:bg-[rgba(0,0,0,0.5)]"
          >
            <motion.div>
              <Link
                to="https://www.instagram.com/p/DKhHDlOIsbv/?igsh=enB0aGI3MmFmY2R6"
                className="relative z-20 grid w-full h-full py-2 text-xl font-bold text-center place-items-center text-secondary hover:text-primary"
              >
                <span>
                  View <br />
                  Gallery
                </span>
              </Link>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  )
}